import React from "react";
import Service from "../Components/Service/Service";

const Features = () => {
  return (
    <div className="container w-screen mx-auto ">
      <Service />
    </div>
  );
};

export default Features;
